'use client';

import React from 'react';
import { Box, HStack, Text, VStack } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
interface SensitiveIngredientItemProps {
  name: string;
  efficacy: string;
  efficacyDescription: string;
  isExpanded?: boolean;
  onToggle?: () => void;
}
const SensitiveIngredientItem = ({
  name,
  efficacy,
  efficacyDescription,
  isExpanded = false,
  onToggle
}: SensitiveIngredientItemProps) => {
  const hasDescription = Boolean(efficacyDescription);
  return <Box background="neutral.50" borderRadius="8px" width="100%" padding={4} data-sentry-element="Box" data-sentry-component="SensitiveIngredientItem" data-sentry-source-file="SensitiveIngredientItem.tsx">
      <VStack gap={3} alignItems="stretch" width="100%" data-sentry-element="VStack" data-sentry-source-file="SensitiveIngredientItem.tsx">
        {/* Header */}
        <HStack gap={3} alignItems="center" justifyContent="space-between" width="100%" data-sentry-element="HStack" data-sentry-source-file="SensitiveIngredientItem.tsx">
          <HStack gap={3} alignItems="center" justifyContent="space-between" flex={1} data-sentry-element="HStack" data-sentry-source-file="SensitiveIngredientItem.tsx">
            <Text textStyle={{
            base: 'label.medium',
            tablet: 'label.large'
          }} fontWeight="medium" color="neutral.500" textAlign="left" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="SensitiveIngredientItem.tsx">
              {name}
            </Text>
            <Text textStyle="label.small" fontWeight="medium" color="error.400" textAlign="left" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="SensitiveIngredientItem.tsx">
              {efficacy}
            </Text>
          </HStack>
          {hasDescription && <Box onClick={onToggle} cursor="pointer">
              <LucideIcon name={isExpanded ? 'CircleMinus' : 'CirclePlus'} size="sm" color="error.400" />
            </Box>}
        </HStack>

        {/* Divider */}
        {isExpanded && hasDescription && <Box height="1px" width="100%" background="neutral.100" marginY={0} />}

        {/* Description */}
        {isExpanded && hasDescription && <Text textStyle={{
        base: 'paragraph.small',
        tablet: 'paragraph.medium'
      }} fontWeight="normal" color="neutral.600" textAlign="left">
            {efficacyDescription}
          </Text>}
      </VStack>
    </Box>;
};
export default SensitiveIngredientItem;